import ClientForm from "@app/components/forms/client-form.tsx";
import { PageContainer } from "@app/components/page-container.tsx";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/_manager/client/$id")({
    component: RouteComponent,
});

function RouteComponent() {
    const { id } = Route.useParams();

    return (
        <PageContainer title={"Update Client"}>
            <ClientForm id={+id} />
        </PageContainer>
    );
}
